import { Component} from '@angular/core';
import {NavController, NavParams, LoadingController, ModalController} from 'ionic-angular';

// Component Imports

// Provider Imports
import {rsProjectSvc} from '../../services/project.service';
import {rsReportSvc} from '../../services/report.service';
import {rsSessionSvc} from '../../services/auth.service';

export interface Options {
  id: number;
  value : number;
  year: number;
}

@Component({
  templateUrl: 'mileage.html',
  providers: []
})
export class MileagePage {
  //private monthVar : number = 10;
  private selectedMonth : Options;

  public options : Options[] = [ 
    { id: 0, value: 1, year: 2016 },
    { id: 1, value: 2, year: 2016 },
    { id: 2, value: 3, year: 2016 },
    { id: 3, value: 4, year: 2016 },
    { id: 4, value: 5, year: 2016 },
    { id: 5, value: 6, year: 2016 },
    { id: 6, value: 7, year: 2016 },
    { id: 7, value: 8, year: 2016 },
    { id: 8, value: 9, year: 2016 },
    { id: 9, value: 10, year: 2016 },
    { id: 10, value: 11, year: 2016 },
    { id: 11, value: 12, year: 2016 },
  ];

  constructor(
    private navCtrl : NavController,
    private navParams : NavParams,
    private loadingCtrl : LoadingController,
    private modalCtrl : ModalController,
    private projectSvc : rsProjectSvc,
    private reportSvc : rsReportSvc,
    private authSvc : rsSessionSvc
  ) {
    // Constructor
  }

  testclick() {
    console.log("Selected Option:  ", this.selectedMonth);
  }
}


// WEBPACK FOOTER //
// ./src/pages/mileage/mileage.component.ts